<div id="loding" [ngClass]="{ 'loding-hide': lodingImage }">
  <img src="assets/img/loding.gif" />
</div>

<div id="ui-view" [ngClass]="{ 'loding-ui-view': showloding }">
  <div class="animated fadeIn">
    <div class="row">
      <div class="col-lg-12" style="margin: auto">
        <div class="card my-3 mx-5">
          <div class="card-block">
            <h4 class="card-title">Temp Mail</h4>

            <form [formGroup]="TempMailForm" (ngSubmit)="onSubmit()">
              <div class="form-group row">
                <label for="to" class="col-md-12 col-form-label"
                  >To <span>*</span></label
                >
                <div class="col-md-12">
                  <input
                    class="form-control"
                    type="text"
                    id="to"
                    formControlName="to"
                  />
                  <span *ngIf="isFieldInvalid('to')" class="text-danger">
                    Please enter a valid email address
                  </span>
                </div>
              </div>

              <div class="form-group row mt-3">
                <label for="subject" class="col-md-12 col-form-label"
                  >Subject <span>*</span></label
                >
                <div class="col-md-12">
                  <input
                    class="form-control"
                    type="text"
                    id="subject"
                    formControlName="subject"
                  />
                  <span *ngIf="isFieldInvalid('subject')" class="text-danger">
                    Subject is required
                  </span>
                </div>
              </div>

              <label for="to" class="col-md-12 col-form-label"
                >Body <span>*</span></label
              >
              <ejs-richtexteditor
                #rteInstance
                [(value)]="value"
                [insertImageSettings]="imageSettings"
                [toolbarSettings]="toolbarSettings"
                formControlName="body"
              ></ejs-richtexteditor>

              <span
                *ngIf="isSubmitted && value.trim() === ''"
                class="text-danger"
              >
                Body is required
              </span>
              <br />

              <button
                type="submit"
                class="btn btn-primary savebtn rounded mt-3"
              >
                Submit
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
